import { z } from "zod";
export const createIcalSourceSchema = z.object({
    name: z.string().min(1).max(200),
    url: z.url(),
    bookings_only: z.boolean().optional(),
});
